import { Typography } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import { makeStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import MuiAlert from '@material-ui/lab/Alert'
import { help } from 'api/help'
import React, { useState } from 'react'

const useStyles = makeStyles(theme => ({
  form: {
    width: '100%',
  },
}))

function HelpContactDialog({ type, open, setOpen }) {
  const classes = useStyles()
  const [values, setValues] = useState({
    message: { value: '', error: '' },
  })
  const [errors, setErrors] = useState([])
  const [loading, setLoading] = useState(false)
  const [submitted, setSubmitted] = useState(false)

  const handleChange = event => {
    const { name, value } = event.target
    setValues({ ...values, [name]: { value: value } })
  }

  const handleSubmit = async event => {
    event.preventDefault()

    setErrors([])
    setLoading(true)
    const result = await help(type, {
      message: values.message.value,
    })
    if (result.success) {
      setLoading(false)
      setSubmitted(true)
    } else {
      setErrors(result.errors)
      setLoading(false)
    }
  }

  const handleCloseRatesDialog = () => {
    setOpen(false)
  }

  return (
    <Dialog open={open} onClose={handleCloseRatesDialog} fullWidth>
      <DialogTitle id='dialog-leasing'>{'How can we help?'}</DialogTitle>
      <DialogContent>
        <DialogContentText id='dialog-leasing-description'>
          {submitted && (
            <MuiAlert severity='success'>
              Your message has been sent, you should receive a response shortly.
            </MuiAlert>
          )}

          {!submitted && (
            <form className={classes.form} noValidate>
              <Typography>
                <p style={{ marginTop: 0 }}>
                  Please enter your message details below, this will be sent to a member
                  of our team to assist.
                </p>
              </Typography>

              <TextField
                disabled={loading}
                variant='outlined'
                margin='normal'
                required
                fullWidth
                multiline
                rows={6}
                id='message'
                label='Message'
                name='message'
                value={values.message.value}
                InputLabelProps={{
                  shrink: true,
                }}
                autoFocus
                onChange={handleChange.bind(this)}
              />
            </form>
          )}

          {errors.length > 0 && (
            <MuiAlert severity='error'>
              {errors.map(error => {
                return <div>{error[1]}</div>
              })}
            </MuiAlert>
          )}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button disabled={loading} onClick={handleCloseRatesDialog} color='primary'>
          Close
        </Button>
        {!submitted && (
          <Button
            disabled={loading}
            onClick={handleSubmit}
            variant='contained'
            color='primary'>
            Submit
          </Button>
        )}
      </DialogActions>
    </Dialog>
  )
}

export default HelpContactDialog
